import { render, staticRenderFns } from "./PanelTT.vue?vue&type=template&id=3bb51d17&scoped=true&"
import script from "./PanelTT.vue?vue&type=script&lang=js&"
export * from "./PanelTT.vue?vue&type=script&lang=js&"
import style0 from "./PanelTT.vue?vue&type=style&index=0&id=3bb51d17&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb51d17",
  null
  
)

export default component.exports